/**
 * React 19 built-in metadata support를 활용한 SEO 컴포넌트
 * React 19에서는 <title>, <meta>, <link>를 컴포넌트 안에서 직접 렌더링하면 <head>에 자동 반영됩니다.
 */
function SEO({ title, description, path = '', image, type = 'website', jsonLd }) {
  const siteName = 'p!nk';
  const baseUrl = 'https://impink.co.kr';
  const defaultDescription = '음원유통 플랫폼 - 최신음악, 플레이리스트, 뮤직비디오, 뮤직트렌드를 만나보세요.';
  const defaultImage = 'https://distribution-pink.s3.ap-northeast-3.amazonaws.com/dev/images/logo.png';

  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} - 음원유통 플랫폼`;
  const desc = description || defaultDescription;
  const url = `${baseUrl}${path}`;
  const img = image || defaultImage;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="ko_KR" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {/* JSON-LD 구조화 데이터 */}
      {jsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      )}
    </>
  );
}

export default SEO;
